module.exports = __webpack_public_path__ + "img/031-boy-12.0cb5cceb.svg";